/* eslint-disable */
import React, { useRef, useCallback, isValidElement, useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import Spinner from 'Components/Spinner'

import useEmblaCarousel from 'embla-carousel-react'

import { DotButton } from 'Components/AppSwiper/components/SwiperDotButtons'
import {
  PrevButton,
  NextButton,
  usePrevNextButtons
} from 'Components/AppSwiper/components/SwiperArrowButtons'

import { _Container, _PrevFade, _NextFade } from './styles'


const isReactElement = (element) =>
  isValidElement(element) &&
  (typeof element.type === 'string' ||
    typeof element.type === 'function' ||
    typeof element.type === 'object')



const AppSwiper = ({
  swiperOptions, children, setEmblaApi,
  onSlideChange = () => {},
}) => {
  const [sliderStatus, setSliderStatus] = useState({
    selectedIndex: 0,
    canScrollNext: false,
    canScrollPrev: false,
  })

  const hasPagination = swiperOptions.pagination
  const hasNavigation = swiperOptions.navigation


  const [emblaMainRef, emblaMainApi] = useEmblaCarousel({ ...swiperOptions })

  const [emblaThumbsRef, emblaThumbsApi] = hasPagination ? useEmblaCarousel({
    containScroll: 'keepSnaps',
    dragFree: true,
    slidesToScroll: 1,
  }) : []

  const onThumbClick = useCallback(
    (index) => {
      if (!emblaMainApi || !emblaThumbsApi) return
      emblaMainApi.scrollTo(index)
    },
    [emblaMainApi, emblaThumbsApi]
  )

  useEffect(() => {
    if (emblaMainApi && setEmblaApi) {
      setEmblaApi(emblaMainApi)
      // console.log(emblaMainApi) // Access API
    }
  }, [emblaMainApi])


  const onSelect = useCallback(() => {
    if (!emblaMainApi) return
    const selectedIndex = emblaMainApi.selectedScrollSnap()
    const canScrollNext = emblaMainApi.canScrollNext()
    const canScrollPrev = emblaMainApi.canScrollPrev()
    setSliderStatus({
      selectedIndex,
      canScrollNext,
      canScrollPrev,
    })

    if (emblaThumbsApi) emblaThumbsApi.scrollTo(emblaMainApi.selectedScrollSnap())

    onSlideChange({
      index: selectedIndex,
      canScrollNext,
      canScrollPrev,
    })
  }, [emblaMainApi, emblaThumbsApi, setSliderStatus])

  useEffect(() => {
    if (!emblaMainApi) return
    onSelect()
    emblaMainApi.on('select', onSelect).on('reInit', onSelect)
  }, [emblaMainApi, onSelect])


  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick
  } = hasNavigation ? usePrevNextButtons(emblaMainApi) : {}



  const renderContent = (elm) => {
    if (!isReactElement(elm)) {
      return null;
    }

    return (
      <div className="embla__slide">
        {
          React.cloneElement(elm, {
            ...elm.props,
          })
        }
      </div>
    )
  }

  const slides = React.Children.map(children, renderContent)

  return(
    <_Container className="embla" ref={emblaMainRef}>
      <div className="embla__container" >
        {slides}
      </div>

      {
        swiperOptions.withContainerFade && sliderStatus.canScrollPrev && 
          <_PrevFade />
      }

      {
        swiperOptions.withContainerFade && sliderStatus.canScrollNext && 
          <_NextFade />
      }


      {
        hasNavigation ?
          <>
            <PrevButton
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                onPrevButtonClick()
              }}
              disabled={prevBtnDisabled}
            />
            <NextButton
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                onNextButtonClick()
              }}
              disabled={nextBtnDisabled}
            />
          </>
          : ''
      }

      {
        hasPagination ?
          <div className="embla__dots">
            <div className="embla__dots__viewport" ref={emblaThumbsRef}>
              <div className="embla__dot__container">
                {slides.map((_, index) => (
                  <DotButton
                    key={index}
                    onClick={() => onThumbClick(index)}
                    selected={index === sliderStatus.selectedIndex}
                    index={index}
                    selectedIndex={sliderStatus.selectedIndex}
                  />
                ))}
              </div>
            </div>
          </div>
          : ''
      }

    </_Container>
  )
}

AppSwiper.propTypes = {
  swiperOptions: PropTypes.shape({}),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element]),
}

export default AppSwiper
/* eslint-enable */
